module.exports = __webpack_public_path__ + "7dd0f2c7071bd1233697c2e7917e1216.pdf";